import { ActionTypes } from 'store/constants';

const userPermissionsInitial = {};
const activityPermissionsInitial = [];

export const userPermissions = (state = userPermissionsInitial, action) => {
    switch (action.type) {
        case ActionTypes.permissions.getUserPermissionsSuccess:
            if (action.payload && action.payload.user_id) {
                return {
                    ...state,
                    [action.payload.user_id]: action.payload
                };
            }
            return state;
        case ActionTypes.permissions.updateUserPermissionsSuccess:
            if (action.payload && action.payload.user_id) {
                return {
                    ...state,
                    [action.payload.user_id]: action.payload
                };
            }
            return state;
        case ActionTypes.permissions.updateUserPermissionsViaSocket:
            if (action.payload && action.payload.user_id) {
                return {
                    ...state,
                    [action.payload.user_id]: action.payload
                };
            }
            return state;
        default:
            return state;
    }
};

export const activityPermissions = (state = activityPermissionsInitial, action) => {
    switch (action.type) {
        case ActionTypes.permissions.listActivityPermissionsSuccess:
            return action.payload;
        case ActionTypes.permissions.updateActivityPermissionsSuccess:
            return action.payload;
        default:
            return state;
    }
};
